export default "__VITE_ASSET__CGqj2CMl__"